export default __webpack_public_path__ + "static/y22-711eca8d81f86714f16f030db36b5cbc.png";